import { getUrl } from "../../../../utils";
import client from "../../../../utils/connected/api";

export const getCredentialsRequest = (filterParams) => client.get(getUrl("credentials", filterParams));

export const createCredentialsRequest = (data) => client.post("credentials", data);

export const deleteCredentialsRequest = (id) => client.delete(`credentials/${id}`);

export const editCredentialsRequest = (data) => client.put(`credentials/${data.id}`, data);
